


















import Vue from 'vue'
import MultiSelect from '@/components/Common/MultiSelect.vue'

interface Options {
  [key: string]: string
}

interface Props {
  filterValue: string
  symbol: string
  options: Options[]
}

interface Data {
  multiValue: string[]
  selectOptions: Options[]
}

interface Methods {
  setUsers: (options: Options[]) => void
  userAvatar: (item: Options) => string
}

interface Computed {
  filterValueArray: string[]
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    MultiSelect,
  },
  props: {
    filterValue: {
      required: true,
    },
    symbol: {
      required: true,
    },
    options: {
      required: true,
    },
  },
  data() {
    return {
      multiValue: [],
      selectOptions: [],
    }
  },
  methods: {
    setUsers(options) {
      if (this.symbol === 'E') {
        const ids = options.map(elem => elem.id).join(`|${this.symbol}`)
        this.$emit('input', ids)
      }
      if (this.symbol === '!E') {
        const ids = options.map(elem => elem.id).join(`,user_id:${this.symbol}`)
        this.$emit('input', ids)
      }
    },
    userAvatar(item) {
      const initails = item.fname.slice(0, 1) + item.lname.slice(0, 1)
      return initails
    },
  },
  computed: {
    filterValueArray() {
      return this.filterValue
        .split('|')
        .map(elem => elem.replace(this.symbol, ''))
    },
  },
  watch: {
    symbol() {
      this.setUsers(this.selectOptions)
    },
  },
})
